import { AxiosError } from "axios";
import { toast } from "sonner";
import { STATUS_MESSAGES } from "../constants/type-vlue";

type ToastOptions = {
  title?: string;
  description?: string;
  duration?: number;
  position?: "bottom-left" | "bottom-right" | "top-left" | "top-right";
};

type ToastLoadingOptions = {
  description?: string;
  titleLoading?: string;
  titleSuccess?: string;
  titleError?: string;
  duration?: number;
  position?: "bottom-left" | "bottom-right" | "top-left" | "top-right";
};

export const showToast = {
  success: (options: ToastOptions) => {
    return toast.success(options.title, {
      description: options.description,
      duration: options.duration || 3000,
      position: options.position || "bottom-right",
    });
  },
  error: (options: ToastOptions) => {
    return toast.error(options.title, {
      description: options.description,
      duration: options.duration || 3000,
      position: options.position || "bottom-right",
    });
  },
  info: (options: ToastOptions) => {
    return toast.info(options.title, {
      description: options.description,
      duration: options.duration || 3000,
      position: options.position || "bottom-right",
    });
  },
  loading: (options: ToastOptions) => {
    return toast.loading(options.title, {
      description: options.description,
      duration: options.duration || 3000,
      position: options.position || "bottom-right",
    });
  },
  promise: <T>(promise: Promise<T>, options: ToastLoadingOptions) => {
    return toast.promise(promise, {
      loading: options.titleLoading || "Processing...",
      success: options.titleSuccess || "Task completed 🎉",
      position: options.position || "bottom-right",
      error: (err: AxiosError) => {
        if (options.titleError) return options.titleError;
        if (!err.code) {
          return err.message;
        }
        if (typeof err === "string" || typeof err === "number") return err;
        if (err.response?.status) {
          const msg = STATUS_MESSAGES[err.response?.status];
          if (msg) {
            return msg;
          }
        }
        if (err?.response?.status === 400) {
          return (err.response.data as { detail: string }).detail;
        }

        return options.titleError || "Something went wrong ❌";
      },

      duration: options.duration || 3000,
      description(value) {
        return typeof value === "string" || typeof value === "number"
          ? value
          : undefined;
      },
    });
  },
  close: (id: string | number) => toast.dismiss(id),
};
